import { DeprecatedTokens } from '@visikon/spine/src/styles/tokens/deprecated-tokens';
import { tracker } from '@visikon/tracker/src';
import * as React from 'react';
import styled from 'styled-components';
import { SideBarContainer } from '../../components/SideBarContainer';
import { I18N } from '../../internationalization/AppText';
import { generateHeaderId } from '../contactPopup/MarkdownRenderer';

interface IProps {
  tableOfContent?: string[] | HTMLElement[];
  docContainer?: HTMLDivElement;
  tocElementClicked?: (key: string) => void;
}

const TocElement = styled.li`
  max-width: 280px;
  font-weight: normal;
  margin-bottom: 20px;
  font-size: 1.2em;
  cursor: pointer;
  color: ${DeprecatedTokens.primary};
`;

export class TableOfContentComponent extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.renderToc = this.renderToc.bind(this);
    this.getClickHandler = this.getClickHandler.bind(this);
  }

  renderToc() {
    if (!this.props.tableOfContent) {
      return null;
    }

    return this.props.tableOfContent.map((element: string | HTMLElement, index: number) => {
      const isString = typeof element === 'string';
      const text = isString ? element : (element as HTMLElement).innerText;

      if (!text || text.trim() === '') {
        return null;
      }

      return (
        <TocElement key={index}>
          <button
            type="button"
            onClick={this.getClickHandler(element)}
            style={{
              color: 'unset',
              background: 'unset',
              border: 'none',
              padding: 'inherit',
              font: 'inherit',
              textTransform: 'inherit',
              textAlign: 'left',
              cursor: 'pointer',
            }}
          >
            {text}
          </button>
        </TocElement>
      );
    });
  }

  getClickHandler(element: string | HTMLElement) {
    return () => {
      const isString = typeof element === 'string';
      const text = isString ? element : (element as HTMLElement).innerText;
      const id = isString ? generateHeaderId(element) : (element as HTMLElement).id;

      // Perform scroll
      tracker.trackEvent('TOC', 'tocItemClick', text);
      if (this.props.tocElementClicked) {
        this.props.tocElementClicked(id);
      }

      if (this.props.docContainer) {
        if (isString) {
          const headerElement = this.props.docContainer.querySelector(`#${id}`) as HTMLElement;
          if (headerElement) {
            this.props.docContainer.scrollTop = headerElement.offsetTop;
          }
        } else {
          this.props.docContainer.scrollTop = (element as HTMLElement).offsetTop;
        }
      }
    };
  }

  render() {
    if (this.props.tableOfContent === undefined || this.props.tableOfContent.length <= 1) {
      return <SideBarContainer />;
    }

    return (
      <>
        <h2>
          <I18N text="table_of_content" />
        </h2>
        <ol style={{ paddingLeft: 30, textAlign: 'left' }}>{this.renderToc()}</ol>
      </>
    );
  }
}
